import type { ReactNode } from 'react'

interface NotConfiguredPageProps {
  missing: string[]
}

export function NotConfiguredPage({ missing }: NotConfiguredPageProps): ReactNode {
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="max-w-md rounded-lg border bg-card p-6 shadow-sm">
        <h1 className="text-lg font-semibold">Admin no configurado</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          El panel no puede inicializar porque faltan variables de entorno.
          Contacta al equipo de infraestructura.
        </p>
        {missing.length > 0 ? (
          <ul className="mt-4 list-disc space-y-1 pl-5 text-xs text-muted-foreground">
            {missing.map((key) => (
              <li key={key}>
                <code>{key}</code>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    </div>
  )
}
